
































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class StatBlock extends Vue {
  @Prop({ required: true, type: String }) public label!: string;
  @Prop({ required: true, type: String }) public value!: string;
  @Prop({ required: true, type: String }) public tooltip!: string;
  @Prop({ default: "", type: String }) public defaultValue!: string;
  @Prop({ default: "", type: String }) public titleFontSize!: string;

  public hover = false;

  get displayValue(): string {
    return String(this.value) === "" ? this.defaultValue : this.value;
  }

  get titleStyle(): { "font-size"?: string } {
    if (
      this.titleFontSize === "" ||
      this.$vuetify.breakpoint.mdAndDown ||
      this.$vuetify.breakpoint.width >= 1500
    )
      return {};
    return {
      "font-size": this.titleFontSize + " !important",
    };
  }
}
